import { NotInSelector } from "../my-schedules/my-custom-schedules/select-schedule"

export function IfMultiSelect({ condition, children }) {
    if (condition) {
        return <>{children}</>
    } else {
        return <NotInSelector>{children}</NotInSelector>
    }
}
